import jwtService from "services/jwtService";
// import { setUserData } from "./user.actions";

export const FORGOT_PASS_FETCH_START = "FORGOT_PASS_FETCH_START";
export const FORGOT_PASS_FETCH_SUCCESS = "FORGOT_PASS_FETCH_SUCCESS";
export const FORGOT_PASS_FETCH_FAILURE = "FORGOT_PASS_FETCH_FAILURE";

export function submitForgot({ mobile, captcha, onSuccess, onError }) {
  return (dispatch, getState) => {
    dispatch({
      type: FORGOT_PASS_FETCH_START,
    });
    jwtService
      .forgotPass({ mobile, captcha })
      .then((response) => {
        // dispatch(setUserData(user));
        onSuccess();
        return dispatch({
          type: FORGOT_PASS_FETCH_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        onError();
        return dispatch({
          type: FORGOT_PASS_FETCH_FAILURE,
          payload: error,
        });
      });
  };
}
